import { MEDIA_POPUP_BROWSE_DEVIATION_STREAM_ID, MEDIA_POPUP_BROWSE_SEARCH_DEVIATION_STREAM_ID, MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP, MEDIA_POPUP_GALLECTION_STREAM_GROUP, MEDIA_POPUP_CUSTOM_DEVIATION_SET_STREAM_ID, MEDIA_POPUP_GALLECTION_DEVIATION_SEARCH_STREAM_GROUP, MEDIA_POPUP_POLL_STREAM_ID, MEDIA_POPUP_STATUS_STREAM_ID, MEDIA_POPUP_JOURNAL_STREAM_ID, MEDIA_POPUP_POSTS_STREAM_ID, MEDIA_POPUP_TIER_STREAM_ID, } from './constants';
import { MediaSourceType } from './types';
import { ALL_FOLDER_ID, SCRAPS_FOLDER_ID } from '@wix/da-url';
import { GallectionType } from '../types/gallection';
import { getDeviationType } from '../DeviationViews/_helpers';
import { DeviationTypes } from '../types/deviation';
import { getIsGif } from '../redux/deviations/selectors';
import { galleryFolderSchema, collectionFolderSchema, stashFolderSchema, } from '../redux/normalizr/schemas/folder';
export function getGallectionStreamId(mediaSource, folderId /* for subfolders stream */) {
    var folderSuffix = folderId ? "-".concat(folderId) : '';
    return "".concat(MEDIA_POPUP_GALLECTION_STREAM_GROUP, "-").concat(mediaSource).concat(folderSuffix);
}
export function getBrowseDeviationStreamId(searchQuery) {
    return searchQuery
        ? MEDIA_POPUP_BROWSE_SEARCH_DEVIATION_STREAM_ID
        : MEDIA_POPUP_BROWSE_DEVIATION_STREAM_ID;
}
export function getPostStreamIdFromMediaSource(mediaSource) {
    switch (mediaSource) {
        case MediaSourceType.POSTS:
            return MEDIA_POPUP_POSTS_STREAM_ID;
        case MediaSourceType.POLL:
            return MEDIA_POPUP_POLL_STREAM_ID;
        case MediaSourceType.STATUS:
            return MEDIA_POPUP_STATUS_STREAM_ID;
        case MediaSourceType.JOURNAL:
            return MEDIA_POPUP_JOURNAL_STREAM_ID;
        default:
            return MEDIA_POPUP_JOURNAL_STREAM_ID;
    }
}
export function getCustomDeviationSetStreamId() {
    return MEDIA_POPUP_CUSTOM_DEVIATION_SET_STREAM_ID;
}
export function getTierStreamId() {
    return MEDIA_POPUP_TIER_STREAM_ID;
}
export function getGallectionDeviationStreamId(mediaSource, folderId, searchQuery) {
    if (searchQuery) {
        return "".concat(MEDIA_POPUP_GALLECTION_DEVIATION_SEARCH_STREAM_GROUP, "-").concat(mediaSource, "$");
    }
    return "".concat(MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP, "-").concat(mediaSource).concat(folderId !== undefined ? "-".concat(folderId) : '');
}
export function getTierDeviationsStreamId(mediaSource, tierId) {
    return "".concat(mediaSource, "-").concat(tierId);
}
export function canGallectionHaveSubfolders(gallection) {
    if (gallection.type === 'collection' ||
        // TODO: this not entirely correct, revisit once backend is updated
        gallection.type === 'stash' ||
        gallection.name === 'Featured' ||
        gallection.folderId === ALL_FOLDER_ID ||
        gallection.folderId === SCRAPS_FOLDER_ID) {
        return false;
    }
    return true;
}
export function isFeaturedGallection(gallection) {
    return gallection.name === 'Featured';
}
// whether gallection can be moved, removed, renamed
export function isGallectionManageable(gallection) {
    if (isFeaturedGallection(gallection) ||
        gallection.folderId === ALL_FOLDER_ID ||
        gallection.folderId === SCRAPS_FOLDER_ID) {
        return false;
    }
    return true;
}
export function canChangeGallectionDescription(gallection) {
    if (gallection.folderId === ALL_FOLDER_ID ||
        gallection.folderId === SCRAPS_FOLDER_ID) {
        return false;
    }
    return true;
}
// whether gallection's deviations and sub-folders can be moved, removed
// also whether gallection can have cover set
export function areGallectionContentsManageable(gallection) {
    if (gallection.folderId === ALL_FOLDER_ID ||
        gallection.folderId === SCRAPS_FOLDER_ID) {
        return false;
    }
    return true;
}
function isGallection(item) {
    return item && item.hasOwnProperty('folderId');
}
export function getGallectionType(item) {
    if (isGallection(item)) {
        return item.type;
    }
    switch (item) {
        case 'gallery':
            return GallectionType.GALLERY;
        case 'collection':
            return GallectionType.COLLECTION;
        case 'stash':
            return GallectionType.STASH;
        default:
            return;
    }
}
export function getFolderIdsDisabledForDeviationCopy(folders, currentFolderId, deviation) {
    if (deviation && !canMakeDeviationPremium(deviation)) {
        return getPremiumFolderIds(folders);
    }
    return currentFolderId !== ALL_FOLDER_ID ? getPremiumFolderIds(folders) : [];
}
export function getPremiumFolderIds(folders) {
    return folders.filter(function (g) { return !!g.premiumFolderData; }).map(function (g) { return g.folderId; });
}
export function canMakeDeviationPremium(deviation) {
    var deviationType = getDeviationType(deviation);
    return ((deviationType === DeviationTypes.IMAGE && !getIsGif(deviation)) ||
        deviationType === DeviationTypes.LITERATURE);
}
export function getGallectionSchemaByType(gallection) {
    var gallectionType = getGallectionType(gallection);
    switch (gallectionType) {
        case GallectionType.STASH:
            return stashFolderSchema;
        case GallectionType.COLLECTION:
            return collectionFolderSchema;
        case GallectionType.GALLERY:
        default:
            return galleryFolderSchema;
    }
}
//# sourceMappingURL=helpers.js.map